import i18n from '../../VueI18n'
import { ordemServicoApi, registryApi } from '../clients/AxiosClients'
import { ouListaVazia } from '../helpers/ouListaVazia'

/**
 * Retorna todoas as Ordens de Servicos cadastradas no banco de dados
 */
const getAllOrdensDeServicos = async (PagNumber, PagSize, FilteringWord) => {
	// return registryApi.get("/OrdemDeServico");
	return ouListaVazia(
		ordemServicoApi.post(`/OrdemServico/GetToCrudTable`, { PagNumber, PagSize, FilteringWord }),
		'ordens de serviço',
	)
}

/**
 * Dropdown para Ordens de Servico para o componente DropdownFK
 * trazendo tambem a fk da fazenda
 */
const getDropdownOrdemDeServicoComFkFazenda = async () => {
	const {
		data: { result },
	} = await registryApi.get('v1/OrdemDeServico/GetDropdown')

	return result.map((ordemDeServico) => {
		return {
			id: ordemDeServico.id,
			[i18n.t('code')]: `OS-${ordemDeServico.orsv_cd_codigo}`,
			[i18n.t('description')]: ordemDeServico.orsv_ds_descricao,
			[i18n.t('farm')]: `FA-${ordemDeServico.fzda_cd_codigo} - ${ordemDeServico.fzda_nm_nome}`,
			[i18n.t('forestStratification')]:
				`EF-${ordemDeServico.esfl_cd_codigo} - ${ordemDeServico.esfl_ds_descricao}`,
			fk_fzda_fazenda: ordemDeServico.fk_fzda_fazenda,
		}
	})
}

/**
 * Cadastrar nova Ordens de Servicos no banco de dados
 * @param {Object} body OrdemDeServico que será cadastrada
 */
export const createOrdemDeServico = async (body) => {
	return ordemServicoApi.post('/OrdemServico', body)
}

/**
 * Atualiza OrdemDeServico no banco de dados
 * @param {Object} body OrdemDeServico que será atualizada
 */
const updateOrdemDeServico = async (body) => {
	return ordemServicoApi.put('/OrdemServico', body)
}

const openPlot = async (data) => {
	return ordemServicoApi.put('/OrdemServico/OpenPlot', data)
}

const closePlot = async (data) => {
	return ordemServicoApi.put('/OrdemServico/ClosePlot', data)
}

/**
 * Lista dos ids de OrdemDeServico que devem ser excluidos do banco de dados
 * nome do parametro deve ser data pois método DELETE do axios obrigatoriamente recebe um argumento 'data'
 * @param {Array} data Lista dos ids de OrdemDeServico
 */
const deleteOrdemDeServicoByIdList = async (data) => {
	return registryApi.delete('v1/OrdemDeServico/DeleteByIdList', { data })
}

/**
 * Retorna planejamento de inventário de qualidade, parcelas e geojsons
 * @param {String} ordemServicoId id da ordem de serviço em questão
 * @param {String} estratoFlorestalId id do estrato florestal vinculado à OS em questão
 */
export const getPlanejamentoDeInventarioFlorestalDeQualidade = async (
	ordemServicoId,
	estratoFlorestalId,
) => {
	return await ordemServicoApi.get(
		`/PlanejamentoDeParcelas/GetPlanejamentoDeInventarioFlorestalDeQualidade?OrdemDeServicoId=${ordemServicoId}&estratoFlorestalId=${estratoFlorestalId}`,
	)
}
/**
 * Retorna planejamento de inventário de instalação, parcelas e geojsons
 * @param {String} ordemServicoId id da ordem de serviço em questão
 * @param {String} estratoFlorestalId id do estrato florestal vinculado à OS em questão
 */
export const getPlanejamentoDeInventarioFlorestalInstalacao = async (
	ordemServicoId,
	estratoFlorestalId,
) => {
	return await ordemServicoApi.get(
		`/PlanejamentoDeParcelas/GetPlanejamentoDeInventarioFlorestalInstalacao?OrdemDeServicoId=${ordemServicoId}&estratoFlorestalId=${estratoFlorestalId}`,
	)
}
export const getPlanejamentoDeInventarioFlorestalContinuo = async (
	ordemServicoId,
	estratoFlorestalId,
) => {
	return await ordemServicoApi.get(
		`/PlanejamentoDeParcelas/GetPlanejamentoDeInventarioFlorestalContinuo?OrdemDeServicoId=${ordemServicoId}&estratoFlorestalId=${estratoFlorestalId}`,
	)
}
export const getPlanejamentoDeInventarioFlorestalPreCorte = async (
	ordemServicoId,
	estratoFlorestalId,
) => {
	return await ordemServicoApi.get(
		`/PlanejamentoDeParcelas/GetPlanejamentoDeInventarioFlorestalPreCorte?OrdemDeServicoId=${ordemServicoId}&estratoFlorestalId=${estratoFlorestalId}`,
	)
}

export const getPlanejamentoAmostrasSingleTrees = async (ordemServicoId, estratoFlorestalId) => {
	return await ordemServicoApi.get(
		`/SingleTrees/GetPlanejamentoSingleTreesInstalacao?ordemDeServicoId=${ordemServicoId}&estratoFlorestalId=${estratoFlorestalId}`,
	)
}

export const getPlanejamentoConcentradorLongRangeInstalacao = async (
	ordemServicoId,
	estratoFlorestalId,
) => {
	return await ordemServicoApi.get(
		`/ConcentradorLongRange/GetPlanejamentoConcentradorLongRangeInstalacao?ordemDeServicoId=${ordemServicoId}&estratoFlorestalId=${estratoFlorestalId}`,
	)
}

export const savePlanejamentoSingleTrees = async (amostras) => {
	return await ordemServicoApi.post('/SingleTrees/CreateInstalacao', amostras)
}

export const openOrdemServico = async (ordemServicoId) => {
	return ordemServicoApi.put(`/OrdemServico/OpenOrdemServico?ordemServicoId=${ordemServicoId}`)
}
export const fecharOrdemServico = async (ordemServicoId) => {
	return ordemServicoApi.put(`/OrdemServico/CloseOrdemServico?ordemServicoId=${ordemServicoId}`)
}

export const unblockOrdemServico = async (ordemServicoId) => {
	return ordemServicoApi.put(`/OrdemServico/UnblockOrdemServico?ordemServicoId=${ordemServicoId}`)
}

export const getAllAmostrasByOrdemServicoId = async (ordemServicoId) => {
	return registryApi.get(`v1/Amostra/GetAllAmostrasByOrdemDeServicoId?id=${ordemServicoId}`)
}

export const savePlanejamentoInstalacaoCLR = async (planejamento) => {
	return ordemServicoApi.post('/ConcentradorLongRange/SavePlanejamento', planejamento)
}

export const getDropdowns = async () => {
	return ordemServicoApi.get(`/OrdemServico/GetDropDowns`)
}

export const getOrdemServicoById = async (id) => {
	return ordemServicoApi.get(`/OrdemServico/GetOrdemServicoById?id=${id}`)
}

export const getInstalacoesSingleTrees = async () => {
	return ouListaVazia(
		ordemServicoApi.get(`/SingleTrees/GetDropDownInstalacao`),
		'instalações single trees',
	)
}
/**
 * Rota para fazer o planejamento de ordem de serviço de cubagem
 */
export const planejarOrdemDeServicoDeCubagem = async (planejamento) => {
	return ordemServicoApi.post(
		`/PlanejamentoDeOrdemDeServicoDeCubagem/PlanejarCubagem`,
		planejamento,
	)
}

/**
 * Retorna o planejamento de uma ordem de servico de cubagem
 * @param {Id da ordem de servico} idOrdemDeServico
 * @returns Retorna o planejamento de cubagem da ordem de servico
 */
export const buscarPlanejamentoDeOrdemDeServicoDeCubagem = async (idOrdemDeServico) => {
	const params = { idOrdemDeServico }
	return ordemServicoApi.get(`/PlanejamentoDeOrdemDeServicoDeCubagem/BuscarPlanejamento`, {
		params,
	})
}

export const buscarDropdownValidacaoConsistencia = async (idEstratoFlorestal) => {
	return ordemServicoApi.get(
		`/OrdemServico/GetDropdownValidacaoConsistencia?idEstratoFlorestal=${idEstratoFlorestal}`,
	)
}

/**
 * Retorna os dados de coleta (operação) de uma ordem de serviço
 * @param {String} id id da ordem de serviço
 * @returns {Object} { dataHoraInicioMedicao, frequenciaColeta, periodoDispColeta }
 */
export const getColetaInfo = async (id) => {
	return ordemServicoApi.get(`/OrdemServico/GetColetaInfo?id=${id}`)
}

export {
	closePlot,
	deleteOrdemDeServicoByIdList,
	getAllOrdensDeServicos,
	getDropdownOrdemDeServicoComFkFazenda,
	openPlot,
	updateOrdemDeServico,
}
